<template>
    <c-dialog ref="dialog" mode="slide" width="50vw" enable-flex mask-close :button="false">
        <c-table ref="listTable" border :paging="false">
            <c-table-column name="work_hour_type" label="类型" width="50">
                <template #default="{data}">
                    <span v-if="data.work_hour_type == 1" style="color: #0D6EFE">在途</span>
                    <span v-if="data.work_hour_type == 2" style="color: green">上班</span>
                </template>
            </c-table-column>
            <c-table-column name="work_date" label="日期" width="80"></c-table-column>
            <c-table-column name="" label="工时" width="50">
                <template #default="{data}">
                    {{data.work_duration_h}}(h)
                </template>
            </c-table-column>
            <c-table-column name="sign_time" label="打卡时间" width="130">
                <template #default="{data}">
                    {{data.clock_in_time}} ~ {{data.clock_out_time||''}}
                </template>
            </c-table-column>
            <c-table-column name="is_overtime" label="是否加班" width="50">
                <template #default="{data}">
                    <span v-if="data.is_overtime == 0">-</span>
                    <span v-if="data.is_overtime == 1" style="color:red">加班</span>
                </template>
            </c-table-column>
            <c-table-column name="" label="加班时长(小时)" width="50">
                <template #default="{data}">
                    <span v-if="data.is_overtime == 0">-</span>
                    <span v-if="data.is_overtime == 1" style="color:red">{{data.overtime_h}}(h)</span>
                </template>
            </c-table-column>
        </c-table>
    </c-dialog>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: 'orderWorkhoursDetail',

    props: {
        id: [String, Number]
    },
    data() {
        return {
        }
    },

    methods: {
        /*********打开编辑框，初始化**********/
        open(data) {
            //填充form表单
            this.$refs.dialog.open({
                title: '工程师【'+data.user_realname+'】工时明细'
            });
            this.request({
                url: '/after/sale/order/work_hours/list',
                data: {
                    order_id: this.id,
                    user_id: data.user_id
                },
                loading: true,
                success: data => {
                    this.$refs.listTable.setData(data);
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>